/***************************************** Slidshow *****************************/

// slideshow
new Swiper("#productSwiper", {
    effect: "fade",
    loop: true,
    navigation: {
        nextEl: '#productSwiperRight,#productSwiperNext',
        prevEl: '#productSwiperLeft',
    },
    pagination: {
        el: '#productSwiperPagination',
        clickable: true
    },
    on: {
        slideChangeTransitionEnd: function () {
            if (document.querySelector(".swiper-slide-active.white")) {
                document.querySelector(".site-header").classList.add("white");
            } else {
                document.querySelector(".site-header").classList.remove("white");
            }
        }
    },
})

/***************************************** Subscribe /Buy Once *****************************/

//add new product to cart
//let formData = { quantity: 1, id: 794864229, properties: { 'Personalize': 'ZHM' } };
function addProduct(formData) {
    return fetch('/cart/add.js', {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(function (data) {
            return data.json();
        })
}


// event listener for options
document.querySelectorAll(".productOptionInput").forEach(function (element) {
    element.addEventListener("change", function () {
        if (document.querySelector(".productOptionInput:checked").value === "16") {
            document.querySelector("#productPrice").textContent = `$54`;
        } else {
            document.querySelector("#productPrice").textContent = `$92`;
        }
    });
});

document.querySelector("#productATC").addEventListener("click", async function (e) {
    e.preventDefault();

    // collect formdata
    let formData = {
        items: []
    };

    // check which bundle we're adding
    if (document.querySelector(".productOptionInput:checked").value === "16") {
        formData.items = [
            {
                id: 28005785862228, // 16 pack of plantpaper
                quantity: 1
            }, {
                id: 45254159335706, // 4 pack of tissues
                quantity: 1
            },
        ];
    } else {
        formData.items = [
            {
                id: 28348548448340, // 32 pack of plantpaper
                quantity: 1
            },
            {
                id: 45254159368474, // 8 pack of tissues
                quantity: 1
            },
        ];
    }

    this.classList.add("loading");

    await addProduct(formData);

    this.classList.remove("loading");

    window.location.href = "/cart";
});

/*********************************** Stars *************/

document.querySelector("#productStars").addEventListener("click", function () {
    document.querySelector("#yotpo").scrollIntoView({
        behavior: "smooth"
    })
});